/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StatementTuitionDiscountLine } from './StatementTuitionDiscountLine';
import {
    StatementTuitionDiscountLineFromJSON,
    StatementTuitionDiscountLineFromJSONTyped,
    StatementTuitionDiscountLineToJSON,
    StatementTuitionDiscountLineToJSONTyped,
} from './StatementTuitionDiscountLine';

/**
 * 
 * @export
 * @interface StatementTuitionBreakdown
 */
export interface StatementTuitionBreakdown {
    /**
     * 
     * @type {number}
     * @memberof StatementTuitionBreakdown
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof StatementTuitionBreakdown
     */
    discountTotal?: number;
    /**
     * 
     * @type {Array<StatementTuitionDiscountLine>}
     * @memberof StatementTuitionBreakdown
     */
    discounts?: Array<StatementTuitionDiscountLine>;
}

/**
 * Check if a given object implements the StatementTuitionBreakdown interface.
 */
export function instanceOfStatementTuitionBreakdown(value: object): value is StatementTuitionBreakdown {
    return true;
}

export function StatementTuitionBreakdownFromJSON(json: any): StatementTuitionBreakdown {
    return StatementTuitionBreakdownFromJSONTyped(json, false);
}

export function StatementTuitionBreakdownFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatementTuitionBreakdown {
    if (json == null) {
        return json;
    }
    return {
        
        'price': json['price'] == null ? undefined : json['price'],
        'discountTotal': json['discountTotal'] == null ? undefined : json['discountTotal'],
        'discounts': json['discounts'] == null ? undefined : ((json['discounts'] as Array<any>).map(StatementTuitionDiscountLineFromJSON)),
    };
}

export function StatementTuitionBreakdownToJSON(json: any): StatementTuitionBreakdown {
    return StatementTuitionBreakdownToJSONTyped(json, false);
}

export function StatementTuitionBreakdownToJSONTyped(value?: StatementTuitionBreakdown | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'price': value['price'],
        'discountTotal': value['discountTotal'],
        'discounts': value['discounts'] == null ? undefined : ((value['discounts'] as Array<any>).map(StatementTuitionDiscountLineToJSON)),
    };
}

